import { Pipe, PipeTransform, inject } from '@angular/core';
import { StyleBackground } from '@23degrees/shared-code/models';
import { isObject } from '@23degrees/shared-code/utilities';
import { GlobalService } from '@23degrees/shared/services/global/global.service';

@Pipe({
  name: 'backgroundBucket',
  pure: true,
  standalone: true,
})
export class BackgroundBucketPipe implements PipeTransform {
  private globalService = inject(GlobalService);

  private migrateBackground = (background: string) => {
    if (background.includes('imagebyid') || background.includes('gradient(') || background.includes('url(') || background.length < 1) {
      return background;
    }

    return `url(${this.globalService.escapeMediaLink(background)})`;
  };

  transform = <T extends string | StyleBackground>(background: T): T => {
    if (background === undefined || background === null) return;

    if (typeof background === 'string') {
      // @ts-ignore
      return this.migrateBackground(background);
    }

    if (isObject(background)) {
      if (background.backgroundImage) {
        // @ts-ignore
        return { ...background, backgroundImage: this.migrateBackground(background.backgroundImage) };
      }

      return background;
    }
  };
}
